import { authorizedFetch } from './utils';
import appConfig from '../config/appConfig';

const baseApi = appConfig.api.baseUrl;


export async function createProfile({ name, searchType, formData }) {
  const response = await authorizedFetch(`${baseApi}/api/Profiles`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name,
      searchType,
      fields: formData
    }),
  });
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function updateProfile({ profileId, name, searchType, formData }) {
  const response = await authorizedFetch(`${baseApi}/api/Profiles/${profileId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name,
      searchType,
      fields: formData
    }),
  });
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function getProfiles(status) {
  let url = `${baseApi}/api/Profiles`;
  if (status !== undefined) {
    url += `?status=${status}`;
  }
  const response = await authorizedFetch(url);
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function getProfile(profileId) {
  const response = await authorizedFetch(`${baseApi}/api/Profiles/${profileId}`);
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function getSearchTypeFieldMappings(searchType) {
  const response = await authorizedFetch(`${baseApi}/api/Profiles/search-types/${searchType}`);
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function deleteProfile(profileId) {
  const response = await authorizedFetch(`${baseApi}/api/Profiles/${profileId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export { baseApi }; 